import _ from "lodash";

export const groupCandidatesByJob = (data) =>
  _.chain(data)
    .groupBy("job.id")
    .map((items) => ({
      job: items[0].job,
      candidates: _.orderBy(items, [
        "candidate.lastName",
        "candidate.firstName",
      ]),
    }))
    .orderBy("job.title")
    .value();
